/**
 * Russian translations for international listing amenity arrays.
 * Keyed by listing slug — must match internationalListings[].slug exactly.
 *
 * Keep the same order as in the data file so diffs are easy to review.
 */
const internationalAmenitiesRu = {
  "la-alqueria-benahavis-villa": [
    "Кондиционер", "Барбекю", "Новостройка", "Рядом со школами",
    "Крытая терраса", "Двойное остекление", "Встроенные шкафы", "Полностью оборудованная кухня",
    "Вид на сад", "Вид на поле для гольфа", "Спортзал", "Джакузи", "Лифт", "Мраморные полы",
    "Панорамный вид", "Частная терраса", "Вид на море", "СПА", "Кладовая",
    "Открытая терраса", "Подсобное помещение", "Инфраструктура рядом", "Подвал",
    "Рядом с гольф-клубом", "Рядом с магазинами", "Столовая", "Камин",
    "Первая линия гольфа", "Полностью меблирована", "Стеклянные двери", "Гостевой туалет",
    "Система умного дома", "Прачечная", "Гостиная", "Вид на горы",
    "Вид на бассейн", "Сауна", "Солнечные панели", "Паровая баня", "Турецкая баня",
    "Тёплый пол (в ванных)", "Видеодомофон",
  ],

  "villa-c44-phuket": [
    "Частный бассейн", "Заглублённая зона отдыха", "Гараж на 3 машины",
    "Главная спальня с ванной", "Кухня-гостиная", "Кладовая",
    "Насосная комната", "Современный интерьер", "Полностью готова", "Готова к заселению",
    "50 м до школы HeadStart", "Доходность 8–10% годовых",
  ],
};

export default internationalAmenitiesRu;
